



















import Vue, {VueConstructor} from 'vue'
import {Quest, Item, Ans} from '@/types/entity/RawResp'
import UiSwitch from '@/components/Ui/ElSwitch/Switch.vue'
export default (Vue as VueConstructor<Vue & {
}>).extend({
  props: {
    data: {} as () => Quest,
    isActive: {
      type: Boolean,
      default: true
    },
    isEdited: Boolean,
    isError: Boolean,
    isDisabled: Boolean,
    index: Number,
    hideRemove: Boolean,
    vals: {
      type: Array as () => string[],
      default: () => []
    },
  },
  components: {
    UiSwitch
  },
  data () {
    return {
      currentVals: this.vals
    }
  },
  computed: {
    currentQuest: {
      get (): Quest {
        return this.data as Quest
      },
      set () {
      }
    }
  },
  methods: {
    isCheckedItem (item: Item): boolean {
      return this.currentVals.some(val => val === item.text)
    },
    onQuestClick () {
      this.$emit('onClick', this.index)
    },
    checkItem (item: Item): void {
      if (this.isActive) {
        this.currentVals = []
        this.currentVals.push(item.text)
        this.onInput()
      }
    },
    onInput (): void {
      this.$emit('check', {qid: this.currentQuest.qid, vals: this.currentVals} as Ans)
    },
  }
})
